import type { FieldConfig } from '../../../FormLayoutGenerator';

export const FIELDS: FieldConfig[] = [
  {
    label: 'holidays_label',
    name: 'finEHolidaysPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'holidays_label',
    name: 'finEHolidaysBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'special_leave_label',
    name: 'finESpecialleavePrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'special_leave_label',
    name: 'finESpecialleaveBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'education_label',
    name: 'finESchoolingPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'education_label',
    name: 'finESchoolingBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'training_label',
    name: 'finETrainingPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'training_label',
    name: 'finETrainingBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'festive_days_label',
    name: 'finEFestivedaysPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'festive_days_label',
    name: 'finEFestivedaysBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'illness_label',
    name: 'finEIllPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'illness_label',
    name: 'finEIllBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'various_own_label',
    name: 'finEVariousownPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },
  {
    label: 'various_own_label',
    name: 'finEVariousownBuhPrc',
    cols: 6,
    inputProps: { min: 0, max: 1, step: 0.01 }
  },

  {
    label: 'age_hours_label',
    name: 'finEAgehoursPrc',
    type: 'text',
    cols: 6
  },
  {
    label: 'age_hours_label',
    name: 'finEAgehoursBuhPrc',
    type: 'text',
    cols: 6
  },

  { label: 'total_nph_label', name: 'totalNph', disabled: true, cols: 6 },
  { label: 'total_nph_label', name: 'totalNphBuh', disabled: true, cols: 6 },

  {
    label: 'percentage_uplift_label',
    name: 'percentageUplift',
    type: 'text',
    disabled: true,
    cols: 6
  },
  {
    label: 'percentage_uplift_label',
    name: 'percentageUpliftBuh',
    type: 'text',
    disabled: true,
    cols: 6
  }
];
